import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

const TEST_SITE_KEY = "10000000-ffff-ffff-ffff-000000000001";

export function usePlatformAuth() {
  const query = useQuery({
    queryKey: ["platform-settings"],
    queryFn: async () => {
      const { data, error } = await supabase.from("platform_settings").select("*");
      if (error) throw error;
      const settings = data as unknown as Array<{ setting_key: string; setting_value: unknown }>;
      return (
        settings?.reduce<Record<string, unknown>>((acc, setting) => {
          acc[setting.setting_key] = setting.setting_value;
          return acc;
        }, {}) ?? {}
      );
    },
    staleTime: 60_000,
  });

  const settings = query.data ?? {};
  const enabled = settings["auth.hcaptcha_enabled"] === true;
  const configuredKey = typeof settings["auth.hcaptcha_site_key"] === "string" ? settings["auth.hcaptcha_site_key"] : "";
  const scope = typeof settings["auth.hcaptcha_scope"] === "string" ? settings["auth.hcaptcha_scope"] : "both";
  const siteKey = configuredKey || TEST_SITE_KEY;

  return {
    googleEnabled: settings["auth.google_enabled"] === true,
    captchaSiteKey: siteKey,
    captchaSignIn: enabled && (scope === "signin" || scope === "both"),
    captchaSignUp: enabled && (scope === "signup" || scope === "both"),
    captchaForgot: enabled && (scope === "signin" || scope === "both"),
  };
}
